import chapter1 from'./chapter1';
import chapter2 from'./chapter2';
import chapter3 from'./chapter3';

const plot = [
  ...chapter1,
  ...chapter2,
  ...chapter3
];

export default plot;
